import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';
import { contactInfo } from '../mockData';

const ReviewsSection = ({ translations, reviews }) => {
  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-brown-900 mb-4">
            {translations.reviewsTitle}
          </h2>
          <p className="text-xl text-brown-700 mt-4">{translations.reviewsSubtitle}</p>
          <div className="w-24 h-1 bg-brown-700 mx-auto mt-6"></div>
        </div>

        {/* Reviews grid */}
        <div className="grid md:grid-cols-2 gap-6 mt-12">
          {reviews.map((review) => (
            <Card key={review.id} className="hover:shadow-lg transition-all duration-300 border-2 border-cream-200 bg-white">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h4 className="font-semibold text-lg text-brown-900">{review.name}</h4>
                    <p className="text-sm text-brown-600 mt-1">{review.date}</p>
                  </div>
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`h-4 w-4 ${
                          i < review.rating ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                </div>
                <p className="text-brown-700 leading-relaxed">{review.comment}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;